module.exports = __webpack_public_path__ + "img/ug.ccaa7a8.svg";